<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex> {{ dialogTitle }} </span>
	<span fxFlex="10" fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color cursor-pointer">
			close
		</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<form (keydown.enter)="$event.preventDefault()" [formGroup]="projectGroupForm" class="full-width">
		<div class="m-t-1">
			<mat-form-field class="full-width">
				<mat-label>Group Name</mat-label>
				<input matInput autocomplete="off" formControlName="name" />
			</mat-form-field>
			<mat-error
				*ngIf="!isGroupNameValid(projectGroupForm.value.name)"
				class="group_name_error_container font-size-12"
			>
				Duplicate group name
			</mat-error>
		</div>

		<div class="m-t-0-5">
			<mat-form-field fxFlex="100">
				<mat-select
					[formControl]="projectGroupForm.get('delayByMinutes')"
					panelClass="select_contaier_large"
					disableOptionCentering
					placeholder="Delay before contacting"
				>
					<mat-select-trigger>
						{{ getSelectLabel() }}
					</mat-select-trigger>
					<mat-option
						*ngFor="let delay of DELAY_OPTIONS"
						[value]="delay.value"
						[disabled]="dialogData.delayByMinutesList?.indexOf(delay.value) !== -1"
						[ngClass]="{
							selected_delay: projectGroupForm.value.delayByMinutes === delay.value,
							active_delay: projectGroupForm.value.delayByMinutes !== delay.value
						}"
						(click)="customDelayInput.value = ''"
					>
						{{ delay.label }}
					</mat-option>
					<mat-option
						#customDelayOption
						[disabled]="!dialogData.groupsCount"
						[ngClass]="{
							selected_delay: customDelayInput.value,
							active_delay: !customDelayInput.value
						}"
						(click)="$event.stopPropagation()"
						[value]="projectGroupForm.value.delayByMinutes"
					>
						<mat-form-field fxFlex="100" floatLabel="never" (click)="$event.stopPropagation()">
							<input
								#customDelayInput
								placeholder="Custom Delay"
								type="number"
								matInput
								class="input_number_field"
								(click)="$event.stopPropagation()"
								(input)="updateDelayByMins($event.target.value)"
								(blur)="
									$event.target.value
										? updateDelayByMins($event.target.value, customDelayOption)
										: null
								"
								[disabled]="!dialogData.groupsCount"
							/>
						</mat-form-field>
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</form>
</mat-dialog-content>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end end" fxLayoutGap="0.5rem">
		<span (click)="closeDialog(null)" class="link m-r-1">
			{{ closeButtonText }}
		</span>
		<button
			(click)="submitForm()"
			color="primary"
			mat-raised-button
			[disabled]="
				projectGroupForm.invalid ||
				dialogData.delayByMinutesList?.indexOf(projectGroupForm.value.delayByMinutes) !== -1 ||
				!isGroupNameValid(projectGroupForm.value.name)
			"
		>
			{{ submitButtonText }}
		</button>
	</div>
</mat-dialog-actions>
